import React from 'react';
import { formatRuntime } from '../../utils/movieUtils';
import StreamingServiceIcon from '../streaming/StreamingServiceIcon';

const Timeslot = ({ 
  date, 
  timeSlot, 
  scheduledMovie, 
  isOccupied, 
  onDragOver, 
  onDrop, 
  onRemoveMovie,
  onDragStart,
  getStreamingServiceById 
}) => {
  const isFirstSlotOfMovie = scheduledMovie && scheduledMovie.timeSlot.id === timeSlot.id;

  return (
    <div
      className={`border-r border-b border-orange-500 h-16 relative ${
        isOccupied ? 'bg-purple-800' : 'bg-gray-800 hover:bg-gray-700'
      }`}
      onDragOver={!isOccupied ? onDragOver : undefined}
      onDrop={!isOccupied ? (e) => onDrop(e, date, timeSlot) : undefined}
    >
      {isFirstSlotOfMovie && scheduledMovie && (
        <div 
          className={`absolute inset-0 ${scheduledMovie.movie.color} border-2 border-orange-400 rounded m-1 flex flex-col justify-center items-center text-white text-xs font-bold overflow-hidden cursor-move group`}
          style={{ 
            height: `${scheduledMovie.slotsSpanned * 4 - 0.5}rem`,
            zIndex: 10 
          }}
          title={`${scheduledMovie.movie.title} (${formatRuntime(scheduledMovie.movie.runtime)}) - Drag to move`}
          draggable={true}
          onDragStart={(e) => {
            const movieWithScheduleFlag = {
              ...scheduledMovie.movie,
              isScheduled: true
            };
            onDragStart(movieWithScheduleFlag);
            e.dataTransfer.effectAllowed = 'move';
          }}
        >
          <div className="text-center px-1 leading-tight flex-1 flex flex-col justify-center">
            <div className="truncate text-xs font-bold">
              {scheduledMovie.movie.title.length > 15 
                ? scheduledMovie.movie.title.substring(0, 15) + '...'
                : scheduledMovie.movie.title}
            </div>
            <div className="text-xs opacity-90 mb-1">
              {formatRuntime(scheduledMovie.movie.runtime)}
            </div>
            
            {scheduledMovie.movie.preferredStreamingService && (
              <div className="mt-1">
                {(() => {
                  const service = getStreamingServiceById(scheduledMovie.movie.preferredStreamingService);
                  return service ? (
                    <div className="bg-black bg-opacity-50 rounded px-1 py-0.5 text-center">
                      <div className="flex items-center justify-center gap-1">
                        <StreamingServiceIcon 
                          service={service} 
                          size="sm" 
                          showName={false}
                          className="text-white"
                        />
                        <span className="text-white text-xs font-semibold truncate max-w-[3rem]">
                          {service.name.length > 8 ? service.name.substring(0, 8) + '...' : service.name}
                        </span>
                      </div>
                    </div>
                  ) : null;
                })()}
              </div>
            )}
          </div>
          
          <button
            onClick={(e) => {
              e.stopPropagation();
              onRemoveMovie(date.toISOString().split('T')[0], scheduledMovie.id);
            }}
            className="absolute top-0 right-0 bg-red-600 hover:bg-red-500 text-white rounded-full w-4 h-4 flex items-center justify-center text-xs opacity-0 group-hover:opacity-100 transition-opacity"
            title="Remove from schedule"
          >
            ×
          </button>
        </div>
      )}
      
      {!isOccupied && (
        <div className="absolute inset-0 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity">
          <div className="text-orange-400 text-xs">Drop here</div>
        </div>
      )}
    </div>
  );
};

export default Timeslot;

